import script from "./DataCenterThemeDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCenterThemeDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DataCenterThemeDrawer.vue?vue&type=style&index=0&id=5f3097cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3097cc"]])

export default __exports__